import React, {useContext, useEffect, useState} from 'react'
import {Box} from '@mui/material'
import {useStyles} from './styles'
import ImgGallery from './ImgGallery'
import Partners from './Partners'
import CarWindow from './CarWindow'
import {Link} from 'react-router-dom'
import ImageCarousel from '../../components/ImageCarousel'
import clsx from 'clsx'
import SpecialCars from './SpecialCars'
import {getAppointmentPageUrl} from '../../ts/routing/routingConstants/AppUrls'
import {LocaleContext} from '../../ts/routing/LangRouter'
import RotateImage from './RotateImage'
import {useTranslation} from 'react-i18next'
import {GalleryInfoContext} from "../../components/GalleryInfoContext";

const TintedGlass = () => {
    const classes = useStyles()
    const {locale} = useContext(LocaleContext)
    const {t} = useTranslation()
    const [partnerIds, setPartnerIds] = useState([])
    const [rates, setRates] = useState([])
    const [specialCars, setSpecialCars] = useState([])
    const {state} = location

    const {galleryInfo} = useContext(GalleryInfoContext);

    // ✅ compute unique URLs directly from contactInfo
    const uniqueImageUrls = React.useMemo(
        () => Array.from(new Set(galleryInfo?.tintedPartnersImages || [])),
        [galleryInfo]
    );

    // ✅ compute unique URLs directly from contactInfo
    // ✅ Transform string URLs to the format ImageCarousel expects
    const carouselSlides = React.useMemo(() => {
        const uniqueUrls = Array.from(new Set(galleryInfo?.tintedHeaderImages || []));
        return uniqueUrls.map((url, index) => ({
            id: index, // or use url as id: id: url
            image: url,
            title: "" // empty title or add appropriate title if available
        }));
    }, [galleryInfo?.tintedHeaderImages]);

    useEffect(() => {
        if (!uniqueImageUrls.length) return;

        // ✅ build objects directly from URLs
        const newImageObjects = uniqueImageUrls.map((url) => ({
            id: url,
            src: url,
        }));

        setPartnerIds(newImageObjects);
    }, [uniqueImageUrls]); // ✅ correct dependency

    return (
        <>
            <Box
                className={classes.background}
                style={{
                    marginTop: '150px',
                }}
            >
                <ImageCarousel slides={carouselSlides}/>
                <Box sx={{marginTop: '50px'}}>
                    <Box className={classes.titleWrapper}>
                        {t('tinted_glass.customize')}
                        <span className={classes.highlight}>{t('tinted_glass.your')}</span>
                        {t('tinted_glass.tint')}
                    </Box>

                    <Box>
                        <RotateImage/>
                    </Box>
                </Box>
                <Box className={classes.btn_box}>
                    <Link
                        to={state?.tintedGlass?.id ? getAppointmentPageUrl(locale) : '#'}
                        className={classes.bookAppointment}
                        onClick={(e) => {
                            if (!state?.tintedGlass?.id) {
                                e.preventDefault();
                                // Scroll to rates section
                                const ratesSection = document.getElementById('rates-section');
                                if (ratesSection) {
                                    ratesSection.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start'
                                    });
                                }
                            }
                        }}
                    >
                        <button className={classes.button}>
                            {t('common.book_appointment')}
                        </button>
                    </Link>
                </Box>
                <Box>
                    <Box className={classes.titleWrapper}>
                        {t('tinted_glass.benefits_of')}
                        <span className={classes.highlight}>
              {t('tinted_glass.tinted')}
            </span>
                        {t('tinted_glass.glass')}
                    </Box>
                    <Box className={classes.serviceContainer}>
                        <Box className={clsx(classes.service_card, classes.first_benefit)}>
              <span className={classes.service_text}>
                {t('tinted_glass.benefits.first_benefit')}
              </span>
                        </Box>
                        <Box className={clsx(classes.service_card, classes.second_benefit)}>
              <span className={classes.service_text}>
                {t('tinted_glass.benefits.second_benefit')}
              </span>
                        </Box>
                    </Box>
                </Box>
                <Box id="rates-section">
                    <Box className={classes.titleWrapper}>
                        {t('tinted_glass.car_window')}
                        <span className={classes.highlight}>{t('tinted_glass.tints')}</span>
                    </Box>
                    <CarWindow images={rates} setImages={setRates}/>
                </Box>

                <Box>
                    <Box className={classes.titleWrapper}>
                        {t('tinted_glass.special')}
                        <span className={classes.highlight}>{t('tinted_glass.cars')}</span>
                    </Box>
                    <SpecialCars images={specialCars} setImages={setSpecialCars}/>
                </Box>

                <Box>
                    <ImgGallery/>
                </Box>
                <Box
                    sx={{
                        background:
                            'linear-gradient(190.51deg, #1A1C3A 0.56%,rgba(252, 252, 252, 0)  63.08%)',
                    }}
                >
                    <Box className={classes.partnersTitle}>
                        {t('common.our')}
                        <span className={classes.highlight}>{t('common.partners')}</span>
                    </Box>
                    <Box
                        sx={{
                            height: '100%',
                            width: '100%',
                            paddingBottom: '40px',
                        }}
                    >
                        <Partners partners={partnerIds}/>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default TintedGlass
